import { v4 as uuidv4 } from 'uuid';
import { IPRFIItem, IRFIInReviewStep } from "../api-generated";
import RFIRejectDetails from "./rfiRejectDetail";
import RFIUpdateBase from "./rfiUpdateBase";
import RFIStatus from "./rfiStatus";
import RFIDueDateDetails from './rfiDueDateDetail';
import { getLatestDueDateItem } from '@shared/utils';

export default class RFIInReviewStep
  extends RFIUpdateBase
  implements IRFIInReviewStep
{
  public QAQCCompliance?: boolean;
  public ManagerId?: string | null;
  public CoordinatorId?: string | null;
  public rfi_reject_detail?: RFIRejectDetails;
  public rfi_reviewer?: string[];
  public rfi_watcher?: string[];
  public tempId?: string;
  public rfi_duedate?: RFIDueDateDetails;

  constructor(contractId: string, item: IPRFIItem) {
    super(contractId, item);
    const isQaqc = item.Status === RFIStatus.Submitted;
    if(isQaqc)
    {
      this.ManagerId = item.ManagerId;
      this.CoordinatorId = item.CoordinatorId;
    } else {
      if(item.IsDraft===true)
      {
        this.rfi_duedate = new RFIDueDateDetails(getLatestDueDateItem(item));
      }
      else {
        this.rfi_duedate = new RFIDueDateDetails();
      }
    }
    
    this.QAQCCompliance = item.IsDraft === false ? true : item.QAQCCompliance !== false;
    this.rfi_reviewer =
      item.rfi_reviewer?.map((i) => {
        return i.ReviewerId ?? "";
      }) ?? [];

    this.rfi_watcher =
      item.rfi_watcher?.map((i) => {
        return i.WatcherId ?? "";
      }) ?? [];

    if (!this.rfi_reject_detail) {
      this.tempId = uuidv4();
      this.rfi_reject_detail = new RFIRejectDetails();
    }
    
  }
}
